import { useEffect, useEffectEvent } from 'react';
import styled from 'styled-components';

import { Dialog } from '#src/components/dialog/index.tsx';
import { isAllowedBridgeOrigin } from '#src/components/offRamp/OffRampKycOnboarding/type.ts';

const Frame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: none;
`;

type Props = {
  url: string;
  onMessage: (data: unknown) => void;
  onClose: () => void;
  sandbox?: string;
};

export const BridgeIframe = ({ url, onMessage, onClose, sandbox }: Props) => {
  const onMessageEvent = useEffectEvent((data: unknown) => {
    onMessage(data);
  });

  useEffect(() => {
    const cb = (event: MessageEvent) => {
      if (!isAllowedBridgeOrigin(event.origin)) return;
      onMessageEvent(event.data);
    };
    window.addEventListener('message', cb);
    return () => window.removeEventListener('message', cb);
  }, []);

  return (
    <Dialog open fullScreen hideHeader disableBackdropClick onClose={onClose}>
      <Frame
        src={url}
        allow="camera; microphone"
        title="Bridge"
        sandbox={sandbox}
      />
    </Dialog>
  );
};
